<template>
  <div id="app">
     <Nav/>
     <router-view class="view"/>
     <Footer/>
  </div>
</template>

<script>
import Nav from './components/global/Nav'
import Footer from './components/global/Footer'
export default {
  name: 'App',
  components: {
    Nav,
    Footer
  }
}
</script>
